import Snapshots from './Snapshots.component';

export default Snapshots;
